import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { inject } from 'mobx-react';
import { updateSearch } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';
import { getDateRangeInput } from 'src/common/stores/adapters';
import { useLocalization } from '@shared-ui/localization-context';
import { LodgingPropertySingleOffer, PropertyOffersFormSubmitType } from '@shared-ui/lodging-property-offers';
import { RefTarget } from '@shared-ui/ref-context';
import { Level, liveAnnounce } from 'uitk-react-utils';
import { handleUpdateResults } from 'components/infosite/single-offer-search';
import { multiItemCompleteSearchCriteria } from 'components/multi-item/utils';
import { parseDate } from '../form/field-wrappers/single-unit-date-field-wrapper';
import { SharedUiFormWrapper } from '../form/form-wrapper';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
export const PropertySingleOfferWrapper = inject('context', 'experiment', 'currentHotel', 'analyticsSearch')(({
  context,
  currentHotel,
  analyticsSearch,
  inputs
}) => {
  var _a;
  if (!currentHotel) {
    return null;
  }
  const history = useHistory();
  const location = history.location;
  const l10n = useLocalization();
  const searchCriteria = currentHotel.searchCriteria;
  const navigateTo = submitUrl => {
    history.push(submitUrl);
  };
  const onUpdateResults = searchCriteria => {
    handleUpdateResults({
      context,
      criteria: searchCriteria.toJSON(multiItemCompleteSearchCriteria),
      history,
      location,
      l10n
    });
  };
  const onUpdateAvailabilityCalendar = (searchCriteria, l10n, startDate, endDate) => {
    // update the offer criteria
    const newCriteria = searchCriteria.clone();
    const dateFormatter = dateInput => l10n.formatDate(new Date(dateInput.year, dateInput.month - 1, dateInput.day), {
      raw: 'yyyy-MM-dd'
    });
    newCriteria.startDate = startDate ? dateFormatter(parseDate(startDate)) : null;
    newCriteria.endDate = endDate ? dateFormatter(parseDate(endDate)) : null;
    handleUpdateResults({
      context,
      criteria: newCriteria,
      history,
      location,
      l10n
    });
  };
  const offersFormSubmit = (history, location, l10n) => (offersFormData, offersSubmitType) => {
    const {
      isChecked,
      adults,
      children,
      petsIncluded,
      startDate,
      endDate
    } = offersFormData;
    switch (offersSubmitType) {
      case PropertyOffersFormSubmitType.TRAVELER_SELECTOR:
        currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.setOfferData({
          adults,
          children,
          petsIncluded
        });
        analyticsSearch === null || analyticsSearch === void 0 ? void 0 : analyticsSearch.newSearchId();
        return;
      case PropertyOffersFormSubmitType.LODGING_ONE_KEY_BURN_SWITCH:
        updateSearch({
          history,
          location,
          newParams: {
            useRewards: String(isChecked !== null && isChecked !== void 0 ? isChecked : false)
          },
          replace: true
        });
        setTimeout(() => liveAnnounce(l10n === null || l10n === void 0 ? void 0 : l10n.formatText(isChecked ? 'common.pointsApplied' : 'common.pointsRemoved'), Level.POLITE), 500);
        return;
      case PropertyOffersFormSubmitType.AVAILABILITY_CALENDAR:
        onUpdateAvailabilityCalendar(searchCriteria, l10n, startDate, endDate);
        analyticsSearch === null || analyticsSearch === void 0 ? void 0 : analyticsSearch.newSearchId();
        return;
      default:
        return;
    }
  };
  const travelerSingleUnitData = {
    inputs: inputs,
    hotelId: String((_a = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.hotelId) !== null && _a !== void 0 ? _a : ''),
    localDateFormat: context === null || context === void 0 ? void 0 : context.localDateFormat,
    dateRangeInput: searchCriteria && getDateRangeInput(searchCriteria),
    offersFormSubmit: offersFormSubmit(history, location, l10n)
  };
  return React.createElement("div", null, React.createElement(RefTarget, {
    name: "Offers",
    tabIndex: 0
  }, React.createElement(ErrorBoundary, {
    label: "lodging.pdp.single.offer"
  }, React.createElement(SharedUiFormWrapper, {
    action: location.pathname,
    onChange: onUpdateResults,
    onSubmit: navigateTo
  }, React.createElement(LodgingPropertySingleOffer, {
    travelerSingleUnitData: travelerSingleUnitData,
    skipSsr: true
  })))));
});
PropertySingleOfferWrapper.displayName = 'PropertySingleOfferWrapper';
export const SharedUiPropertySingleOfferWrapper = withSharedUiPropertyOffers(PropertySingleOfferWrapper);